import { nullDataChartLabel } from '../nullData';
import type { ReportFieldType } from './types';

export const text: ReportFieldType = {
  asyncOptionSuggestions: true,
  exportVal: ({ fieldData }) => {
    const value = fieldData.value;

    if (value === null || value === undefined) {
      return '';
    }

    return String(value);
  },
  cell: ({ fieldData }) => {
    const value = fieldData.value;

    // Render the standard placeholder for empty/uncategorised values (e.g. a Tier 1
    // category that resolves to nothing) rather than a blank cell, matching the
    // register convention `item.T1CategoryTitle || '-'` (RSP-6056).
    if (value === null || value === undefined || value === '') {
      return '-';
    }

    return value;
  },
  getChartLabel: ({ fieldData }) => {
    return (fieldData.value as string) ?? nullDataChartLabel();
  },
  propertyConfig(field) {
    return {
      key: field.key,
      groupValuesLabel: field.groupValuesLabel,
      propertyLabel: field.propertyLabel,
      operators: ['=', '!=', ':', '!:'],
    };
  },
};
